(() => {
  const emptyState = {
    transclude: true,
    template: `
      <div class="empty-state">
        <img class="empty-state-icon" alt="Empty state icon" ng-src="{{$ctrl.icon}}"/>
        <h3 class="empty-state-title" ng-bind="$ctrl.title" ng-if="$ctrl.title"></h3>
        <p class="empty-state-message" ng-bind="$ctrl.message" ng-if="$ctrl.message"></p>
        <div ng-transclude></div>
      </div>
    `,

    controller() {
      this.$onInit = () => {
        this.icon = this.icon || '/assets/images/icons/thumbs_up.png';
      };
    },

    bindings: {
      icon: '<',
      title: '<',
      message: '<'
    }
  };
  angular.module('pims').component('emptyState', emptyState);
})();